module.exports = __webpack_public_path__ + "static/media/ATA-BNB.0dc9a214.svg";